function convertCidToLabel(dataSet, cid) {
	try {
		return dataSet.find(c => c.cid === cid).label;
	} catch (e) {
		console.error('Error converting cid to label:', e);
		return cid;
	}
}

export const pushToGTM = (...tags) => {
	try {
		tags.forEach(tag => window.dataLayer.push(tag));
	} catch (e) {
		console.error('Error pushing tag:', e);
	}
};

export default pushToGTM;

export const downloadTableCsvTagGA4 = () => ({
	prtUpdateGA4: {
		action: 'download',
		label: 'Product Table CSV'
	},
	event: 'prtUpdateGA4'
});

export const selectCategoryTagGA4 = categoryName => ({
	prtUpdateGA4: {
		action: 'select_category',
		label: categoryName
	},

	event: 'prtUpdateGA4'
});

export const openCategoryTagGA4 = categoryName => ({
	prtUpdateGA4: {
		action: 'open_category',
		label: categoryName
	},

	event: 'prtUpdateGA4'
});

export const topologyOpenedByGA4 = method => ({
	prtUpdateGA4: {
		action: 'topology_was_opened_by',
		label: method
	},

	event: 'prtUpdateGA4'
});

export const selectTableColumnTagGA4 = (columns, cid) => ({
	prtUpdateGA4: {
		action: 'select_or_unselect_table_column',
		label: convertCidToLabel(columns, cid)
	},

	event: 'prtUpdateGA4'
});

export const usedFilterTagGA4 = (filters, cid) => ({
	prtUpdateGA4: {
		action: 'use_filter',
		label: convertCidToLabel(filters, cid)
	},

	event: 'prtUpdateGA4'
});

export const redirectToProductPageTagGA4 = () => ({
	prtUpdateGA4: {
		action: 'redirect_to',
		label: 'Product page'
	},

	event: 'prtUpdateGA4'
});

export const redirectToProductDatasheetGA4 = productNumber => ({
	prtUpdateGA4: {
		action: 'redirect_to',
		label: productNumber ? 'Datasheet' : 'Request Datasheet'
	},

	event: 'prtUpdateGA4'
});

export const clickEvalWithWebDesignerTagGA4 = () => ({
	prtUpdateGA4: {
		action: 'evaluate_by',
		label: 'WebDesigner+'
	},
	event: 'prtUpdateGA4'
});

export const redirectToWebDesignerGA4 = () => ({
	prtUpdateGA4: {
		action: 'redirect_to',
		label: 'WebDesigner+'
	},

	event: 'prtUpdateGA4'
});

export const redirectToTibosGA4 = () => ({
	prtUpdateGA4: {
		action: 'redirect_to',
		label: 'SPICE Live Model'
	},

	event: 'prtUpdateGA4'
});

export const redirectToElitePairingStudioGA4 = () => ({
	prtUpdateGA4: {
		action: 'redirect_to',
		label: 'Elite Pairing Studio'
	},

	event: 'prtUpdateGA4'
});

export const shareFiltersGA4 = () => ({
	prtUpdateGA4: {
		action: 'share',
		label: 'Filters'
	},

	event: 'prtUpdateGA4'
});
